import { render, staticRenderFns } from "./FormInstallmentPlanKTC.vue?vue&type=template&id=2b11b402&scoped=true&"
import script from "./FormInstallmentPlanKTC.vue?vue&type=script&lang=js&"
export * from "./FormInstallmentPlanKTC.vue?vue&type=script&lang=js&"
import style0 from "./FormInstallmentPlanKTC.vue?vue&type=style&index=0&id=2b11b402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11b402",
  null
  
)

export default component.exports